import {
    Component,
    OnInit,
    Input,
    ViewChild,
    ChangeDetectorRef,
    ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'app-lazy-loaded-image',
    templateUrl: './lazy-loaded-image.component.html',
    styleUrls: ['./lazy-loaded-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LazyLoadedImageComponent implements OnInit {
    @Input() ImageSource: string;
    @Input() FallBackImageSource: string;
    @Input() ExcludedPatterns: string[] = ['.*notfound\.?png$'];

    @ViewChild('lazyImage') image;
    @ViewChild('lazyImageWrapper') wrapper;

    minimumHeight: number = null;

    get excludedFile (): boolean {
        if (this.ExcludedPatterns.length > 0) {
            const patternMatched = this.ExcludedPatterns.filter(pattern => {
                const regexp = new RegExp(pattern, 'i');
                return regexp.test(this.ImageSource);
            });
            if (patternMatched.length > 0) {
                return true;
            }
        }
        return false;
    }

    constructor(
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        if (this.excludedFile) {
            this.ImageSource = this.FallBackImageSource;
        }
    }

    loadFallbackImage(event) {
        event.srcElement.src = this.FallBackImageSource;
    }

    onloadImage (event) {
        this.wrapper.nativeElement.classList.remove('loading');
        this.wrapper.nativeElement.setAttribute('style', 'background-image: url(' + event.srcElement.src + ')');
        this.cd.detectChanges();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/lazy-loaded-image/lazy-loaded-image.component.ts